export default __webpack_public_path__ + "static/media/bigManagerLogin.96f5dd9f.png";